// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1cg_V","selects":"Documents_selects__2M_Ws"};